/*
 * @Descripttion: 城市缓存（localStorage，跨会话保留，减少定位请求与高德配额消耗）
 * @version: 2.0.0.0
 */
const CITY_CACHE_KEY = 'geo_city_v1'
const CITY_CACHE_TTL = 12 * 60 * 60 * 1000

export const readCityCache = () => {
  try {
    const raw = localStorage.getItem(CITY_CACHE_KEY)
    if (!raw) return ''
    const { city, ts } = JSON.parse(raw)
    if (!city || !ts || Date.now() - ts > CITY_CACHE_TTL) {
      localStorage.removeItem(CITY_CACHE_KEY)
      return ''
    }
    return city
  } catch (e) {
    return ''
  }
}

export const writeCityCache = (city) => {
  if (!city) return
  try {
    localStorage.setItem(CITY_CACHE_KEY, JSON.stringify({ city, ts: Date.now() }))
  } catch (e) {
    // 隐私模式或存储配额满，忽略即可
  }
}

export const clearCityCache = () => {
  try {
    localStorage.removeItem(CITY_CACHE_KEY)
  } catch (e) {
    // ignore
  }
}
